import { mapGetters } from 'vuex';
import marketTrendsChart from '@/market-trends/components/markettrendschart/markettrends-chart.vue';
import marketTrendsDropdown from '@/market-trends/components/markettrendsdropdown/markettrends-dropdown.vue';
import marketTrendsTabHeader from '@/market-trends/components/markettrendstabheader/markettrends-tabheader.vue';

export default {
    name: 'marketTrendsTab',
    inject: ['$eventBus'],
    components: {
        marketTrendsChart,
        marketTrendsDropdown,
        marketTrendsTabHeader,
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        filterType: {
            default: '',
        },
        widgetOptions: {
            type: Object,
            default: null,
        },
        hasOneMonthData: {
            type: Boolean,
            default: true,
        },
        tabIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isActive: true,
            marketTrendTypes: [
                { id: 'all', name: 'House and Condo/Townhouse' },
                { id: 'condo', name: 'Condos/Townhome' },
                { id: 'single', name: 'House' },
            ],
            selectedMarketTrend: {
                id: 'all',
                name: 'House and Condo/Townhouse',
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getMetric() {
            return this.data.metric;
        },
    },
    mounted() {
        var that = this;
        this.$eventBus.$on('eventbus-selectTab', (value) => {
            that.isActive = (that.tabIndex === value);
        });
    },
    methods: {
        updateSelectedMarketTrend(value) {
            this.$emit('updateMarketTrend', value);
            this.selectedMarketTrend = value;
        },
    },
};
